import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';

const MOCK_DATA = [
  { name: 'Mon', messages: 124, revenue: 12.4 },
  { name: 'Tue', messages: 189, revenue: 18.9 },
  { name: 'Wed', messages: 156, revenue: 15.6 },
  { name: 'Thu', messages: 203, revenue: 20.3 },
  { name: 'Fri', messages: 245, revenue: 24.5 },
  { name: 'Sat', messages: 198, revenue: 19.8 },
  { name: 'Sun', messages: 167, revenue: 16.7 },
];

const chartTooltipStyle = {
  backgroundColor: '#18181f',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: '12px',
  color: '#fff',
};

export function AdminAnalyticsPage() {
  return (
    <div>
      <h1 className="font-['Poppins',sans-serif] text-4xl font-semibold text-white mb-3">
        Analytics
      </h1>
      <p className="text-lg text-[#9595a5] mb-10">Usage and revenue (placeholder data)</p>

      <div className="space-y-10">
        <div>
          <h2 className="font-['Poppins',sans-serif] text-2xl font-semibold text-white mb-6">
            Message Activity
          </h2>
          <div className="p-6 rounded-xl bg-[#18181f] border border-white/[0.08]">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={MOCK_DATA}>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
                <XAxis dataKey="name" stroke="#9595a5" />
                <YAxis stroke="#9595a5" />
                <Tooltip contentStyle={chartTooltipStyle} />
                <Bar dataKey="messages" fill="#ffffff" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div>
          <h2 className="font-['Poppins',sans-serif] text-2xl font-semibold text-white mb-6">
            Revenue Trends
          </h2>
          <div className="p-6 rounded-xl bg-[#18181f] border border-white/[0.08]">
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={MOCK_DATA}>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
                <XAxis dataKey="name" stroke="#9595a5" />
                <YAxis stroke="#9595a5" />
                <Tooltip contentStyle={chartTooltipStyle} />
                <Line type="monotone" dataKey="revenue" stroke="#10b981" strokeWidth={3} dot={{ fill: '#10b981' }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
